var _defs, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "3,2 21,2 21,22 3,22 3,2 3,2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153664204254828330870000005948778917185735553_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000153664204254828330870000005948778917185735553_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.3,19.3l0.3-0.5l-2.8,0.4L13.5,19l-0.6-0.1l-0.5,0.3l-0.2-0.3l0,0.2l-0.4,0.1l-0.2,0.6l3,1.6l0.2,0.4 l1.1,0.3l0.2-1.4h-0.2L16.3,19.3L16.3,19.3L16.3,19.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.4,6.6L3.3,6.9L4,7.4l0.4-0.1l0.1,0.5L4.2,8.1v0.1l0.5,0.1l1.1-1.1l2,0.8l1.7,2.7L9.5,11l2.5,1.9h0.2 l0.3,0.4h0.3l0.1-0.2l0.8,0.1l0.5,0.8h0.3l0.1,0.5l0.3,0.1l0.2-0.2l0.6,0.4l-0.1,0.5l0.7,0.4l0.5-0.1l0.7,2.4h-0.2l-0.6,1.4 l0.1,0.1l0.7-0.3l0.7-1.5l0.8-0.2l-0.1-1l-0.7-0.7l0-0.6l0.4-0.3l2.3,0.8l0-0.6l-3.9-2.5l0.4-0.4l-2.8-0.9v0l-3.5-4.4l0.3-0.5 l-0.3-0.8l0.2-0.6l0.1,0.1l0.1,0l1.1-0.8l0.4,0.1V4l-0.1,0L13,3.7l0.1-0.1l-0.1,0l-0.2-0.4l0-0.1l0.3-0.1v0l-1.8-0.4l-0.3-0.5 l-2,0.6L8.8,2.3H8.7L8.6,2.8L8.5,2.9L8.2,2.8v0.7L7,3.1l0,0.4L6.7,3.6L6.6,4.2l-0.3,0L5.9,3.9l0-0.2L5.4,3.4l0-0.3H5.4l-0.7,1 l-1.3,0L3.2,4.2l0.4,0.7L3.5,5.3L3,5.5L3.1,6l0.4,0.2l0,0.1L3.4,6.6L3.4,6.6L3.4,6.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/IT.42b6748f.svg";
export { ForwardRef as ReactComponent };